import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type CollapsibleState = {
  isOpen: boolean;
};

type ProductCollapsiblesState = {
  [productSlug: string]: {
    collapsibles: Record<string, CollapsibleState>;
  };
};

const initialState: ProductCollapsiblesState = {};

export const productCollapsiblesSlice = createSlice({
  name: 'productCollapsibles',
  initialState,
  reducers: {
    setCollapsibleState: (state, action: PayloadAction<{
      productSlug: string;
      collapsibleId: string;
      isOpen: boolean;
    }>) => {
      const { productSlug, collapsibleId, isOpen } = action.payload;

      if (!state[productSlug]) {
        state[productSlug] = {
          collapsibles: {}
        };
      }

      state[productSlug].collapsibles[collapsibleId] = { isOpen };
    },

    resetProductCollapsibles: (state, action: PayloadAction<string>) => {
      const productSlug = action.payload;
      delete state[productSlug];
    }
  }
});

export const { setCollapsibleState, resetProductCollapsibles } = productCollapsiblesSlice.actions;
export default productCollapsiblesSlice.reducer;
